<template>
    <div>
        <div class="box">
            <div class="title">预 警 处 理 情 况</div>
            <div class="unde">
                <div class="left">
                    <div>
                        <div>当日事件</div>
                        <div class="num">{{formData.total}}个</div>
                    </div>
                    <div>
                        <div>已处理</div>
                        <div class="num">{{formData.confirm_count}}个</div>
                    </div>
                    <div>
                        <div>未处理</div>
                        <div class="num">{{formData.untreated_count}}个</div>
                    </div>
                </div>
                <div class="chart right" ref="grade"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { dataBoardWarn } from "@/api/index";
export default {
    data() {
        return {
            pieData: [],
            formData: {
                confirm_count: 0,
                total: 0,
                untreated_count: 0,
            },
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        async getList() {
            const res = await this.axios.post(dataBoardWarn);
            if (res.data.code == 1) {
                this.formData = res.data.data.today;
                this.pieData = res.data.data.today.warn_count;
                this.getStudent();
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },
        getStudent() {
            const chart = this.$refs.grade;
            const myChart = this.$echarts.init(chart);
            const option = {
                title: {
                    text: '',
                    subtext: '',
                    left: 'center',
                    textStyle: {
                        fontSize: '12',
                        color: '#fff',
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{b} : {c} ({d}%)",
                },
                legend: {
                    orient: 'vertical',
                    left: 'right',
                    textStyle: {
                        color: '#fff'
                    }
                },
                color: ['#ff7022', '#15d04d', '#0091ff', '#7c67f2', '#d15edd', '#c615d0'],
                series: [
                    {
                        name: '预 警 处 理 情 况',
                        type: 'pie',
                        radius: '50%',
                        data: this.pieData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                    }
                ]
            }
            option && myChart.setOption(option)
        }
    },
}
</script>

<style lang='scss' scoped>
.box {
    width: 100%;
    height: 100%;
    // background-color: #21274d;
    .title {
        font-size: 16px;
        color: #fff;
    }
    .unde {
        width: 100%;
        height: 100%;
        display: flex;
        .left {
            flex: 1;
            width: 30%;
            flex-basis: 30%;
            height: 100%;
            color: #fff;
            margin-top: 10%;
            .num {
                font-size: 40px;
            }
        }
        .chart {
            flex: 1;
            flex-basis: 70%;
            min-height: 300px;
            margin-top: 10%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/dataBoard/pieChart.vue